import React, {useState} from 'react'
import {PaymentElement, useElements, useStripe} from "@stripe/react-stripe-js";

interface SaveCardFormProps {
  onCardSaved: (paymentMethodId: string) => void
}

/**
 * A form to collect and save a payment method via SetupIntent
 */
export const SaveCardForm: React.FC<SaveCardFormProps> = ({onCardSaved}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!stripe || !elements) return

    setLoading(true)
    const result = await stripe.confirmSetup({
      elements,
      redirect: 'if_required',
    })
    setLoading(false)

    if (result.error) {
      setError(result.error.message || 'Unable to save payment method')
    } else if (result.setupIntent) {
      onCardSaved(result.setupIntent?.payment_method as string ?? '')
      setSuccess(true)
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <PaymentElement/>

      {error && <p className="text-sm text-red-500">{error}</p>}

      <button
        type="submit"
        disabled={!stripe || loading}
        className="w-full py-2 rounded-lg bg-green-500 text-white hover:bg-green-600 disabled:opacity-50 flex justify-center items-center"
      >
        {loading ? 'Saving...' : success ? 'Card saved' : 'Save Card'}
      </button>
    </form>
  )
}
